var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarcadorEmpresa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Uni\\xF3n_273",
    x: -2,
    y: -2.727,
    width: 54,
    height: 58.471,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-marcadorEmpresa"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "marcadorEmpresa",
    clipPath: "url(#clip-marcadorEmpresa)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17221",
    "data-name": "Grupo 17221"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Uni\\xF3n_273)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Uni\\xF3n_273-2",
    "data-name": "Uni\\xF3n 273",
    transform: "translate(7 3.27)",
    fill: "#222d63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18.49995040893555 39.97007751464844 C 18.35256004333496 39.97007751464844 18.21830940246582 39.90861892700195 18.12192916870117 39.7970085144043 L 13.69672012329102 34.67327880859375 L 13.54714012145996 34.50009918212891 L 13.31830978393555 34.50009918212891 L 7.000199794769287 34.50009918212891 C 3.415980100631714 34.50009918212891 0.5 31.5841178894043 0.5 27.99989891052246 L 0.5 7.000198841094971 C 0.5 3.415978670120239 3.415980100631714 0.4999987483024597 7.000199794769287 0.4999987483024597 L 28.99979972839355 0.4999987483024597 C 32.58401870727539 0.4999987483024597 35.5 3.415978670120239 35.5 7.000198841094971 L 35.5 27.99989891052246 C 35.5 31.5841178894043 32.58401870727539 34.50009918212891 28.99979972839355 34.50009918212891 L 23.68158912658691 34.50009918212891 L 23.45276069641113 34.50009918212891 L 23.30318069458008 34.67327880859375 L 18.87799072265625 39.79697799682617 C 18.78158950805664 39.90861892700195 18.64734077453613 39.97007751464844 18.49995040893555 39.97007751464844 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 18.49967193603516 39.47007369995117 L 18.49958992004395 39.47016906738281 L 23.22393035888672 34.00009918212891 L 28.99979972839355 34.00009918212891 C 32.30831909179688 34.00009918212891 35 31.30841827392578 35 27.99989891052246 L 35 7.000198841094971 C 35 3.691678762435913 32.30831909179688 0.9999987483024597 28.99979972839355 0.9999987483024597 L 7.000199794769287 0.9999987483024597 C 3.691679954528809 0.9999987483024597 1 3.691678762435913 1 7.000198841094971 L 1 27.99989891052246 C 1 31.30841827392578 3.691679954528809 34.00009918212891 7.000199794769287 34.00009918212891 L 13.77597045898438 34.00009918212891 L 18.4986400604248 39.4699592590332 C 18.49875259399414 39.46998596191406 18.49913024902344 39.47005462646484 18.49967193603516 39.47007369995117 M 18.49995040893555 40.47007751464844 C 18.22139930725098 40.47007751464844 17.94285011291504 40.35464859008789 17.74349975585938 40.12379837036133 L 13.31830978393555 35.00009918212891 L 7.000199794769287 35.00009918212891 C 3.133800029754639 35.00009918212891 0 31.86629867553711 0 27.99989891052246 L 0 7.000198841094971 C 0 3.133798837661743 3.133800029754639 -1.242675807588967e-06 7.000199794769287 -1.242675807588967e-06 L 28.99979972839355 -1.242675807588967e-06 C 32.8661994934082 -1.242675807588967e-06 36 3.133798837661743 36 7.000198841094971 L 36 27.99989891052246 C 36 31.86629867553711 32.8661994934082 35.00009918212891 28.99979972839355 35.00009918212891 L 23.68158912658691 35.00009918212891 L 19.25639915466309 40.12379837036133 C 19.05705070495605 40.35464859008789 18.77849960327148 40.47007751464844 18.49995040893555 40.47007751464844 Z",
    stroke: "none",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "home_work-24px",
    transform: "translate(13 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6486",
    "data-name": "Trazado 6486",
    d: "M17,15h2v2H17Zm0-4h2v2H17Zm0-4h2V9H17ZM13.74,7,15,7.84V7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6487",
    "data-name": "Trazado 6487",
    d: "M10,3V4.51l2,1.33V5h9V19H17v2h6V3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6488",
    "data-name": "Trazado 6488",
    d: "M8.17,5.7,15,10.25V21H1V10.48ZM10,19h3V11.16L8.17,8.09,3,11.38V19H6V13h4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6489",
    "data-name": "Trazado 6489",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarcadorEmpresa);
export default __webpack_public_path__ + "static/media/marcadorEmpresa.e58c29011ce250190568aa7b610ba6a4.svg";
export { ForwardRef as ReactComponent };